import { render, staticRenderFns } from "./ActivityGrid.vue?vue&type=template&id=9b36a98a"
import script from "./ActivityGrid.vue?vue&type=script&lang=js"
export * from "./ActivityGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports